import styled from 'styled-components';

const Title = styled.form`
  width: 100%;
  h1 {
    color: white;
  }
`;

export default Title;
